import { useAccount, useChainId, useConfig } from 'wagmi';

import { Environment } from '../enums';

export interface ChainConfig {
  developmentChainId: number;
  productionChainId: number;
}

export interface Web3HookConfig {
  chainConfig: ChainConfig;
  environment: Environment;
}

export const createWeb3Hook = ({ chainConfig, environment }: Web3HookConfig) => {
  return () => {
    const { address, chain } = useAccount();
    const config = useConfig();
    const chainId = useChainId();

    const targetChainId =
      environment === Environment.DEV ? chainConfig.developmentChainId : chainConfig.productionChainId;

    const isWrongNetwork = chainId !== targetChainId;

    return { address, config, chainId, isWrongNetwork, chain };
  };
};
